import { createFileRoute } from '@tanstack/react-router'

import { DriverRechargeError } from '@/pages/driver-recharge-error'

export const Route = createFileRoute('/_protected/driver-recharge/error')({
    component: DriverRechargeError,
})
